module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=modal-header>{{'cenceo.mail.sent' | translate}}</div> <div class=modal-footer> <button type=button class=\"btn btn-default\" ng-click=$hide()>{{'cenceo.mail.sent.ok' | translate}}</button> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite/salary-invite.modal.mail-sent.html
 ** module id = 199
 ** module chunks = 0
 **/